import styled from 'astroturf/react';

const Placeholder = styled.div<{ small?: boolean }>`
  background: #eee;
  border-radius: 48px;
  height: 24px;
  margin-bottom: 12px;
  overflow: hidden;
  position: relative;
  width: 40%;

  &.small {
    border-radius: 32px;
    display: inline-block;
    height: 16px;
    margin-right: 16px;
    width: 12%;
  }

  &::after {
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(128, 128, 128, 0.12) 40%,
      rgba(128, 128, 128, 0.12) 60%,
      transparent 100%
    );
    background-repeat: no-repeat;
    background-size: 50%;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;

    animation-name: swipe;
    animation-duration: 1.4s;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
    animation-iteration-count: infinite;
    @keyframes swipe {
      0% {
        background-position-x: -100%;
      }
      100% {
        background-position-x: 200%;
      }
    }
  }
`;

export default Placeholder;
